import Base from "./Base";
import ErrorBoundary from "./ErrorBoundary";

const MainApp = () => {

  return (
    <>
      <ErrorBoundary>
        {/* <Partytown debug={true} forward={["dataLayer.push"]} /> */}
        <Base />
      </ErrorBoundary>
    </>
  );
};
export default MainApp;
